'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Logo from './Logo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 12);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-200 ${
        scrolled
          ? 'bg-[#f4f6f5]/95 backdrop-blur-md shadow-subtle border-b border-[#e2e8e4]'
          : 'bg-[#f4f6f5] border-b border-[#e2e8e4]/60'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Brand lockup */}
          <div className="flex-shrink-0">
            <Logo variant="horizontal" />
          </div>

          {/* Minimized Navigation */}
          <nav className="flex items-center space-x-2 sm:space-x-3" aria-label="Main navigation">
            <Link
              href="/about"
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                pathname === '/about'
                  ? 'text-[#2d5a3d] font-semibold bg-[#e8f0eb]'
                  : 'text-[#1a2332] hover:text-[#2d5a3d] hover:bg-[#e8f0eb]/50'
              }`}
            >
              About
            </Link>

            <Link
              href="/contact"
              className={`px-4 py-1.5 text-sm font-semibold rounded-md transition-all shadow-subtle ${
                pathname === '/contact'
                  ? 'bg-[#3d7a52] text-white'
                  : 'bg-[#2d5a3d] text-white hover:bg-[#3d7a52]'
              }`}
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
